import $ from "jquery";

export default function (options) {
  function loading(that, bool) {
    const actionClass = bool ? "addClass" : "removeClass";

    that.loading = bool;
    that.box.find(".mdi-refresh")[actionClass]("mdi-spin");
  }

  function isClean(that, msg) {
    setPagination(that);
    that.boxContent.html(
      `<div class="siggma-notify-clean">${msg || "Nenhuma notificação!"}</div>`,
    );
  }

  function setPagination(that, page, pagination) {
    that.page = page || 1;

    if (that.page > 1 && pagination?.page === 1) {
      pagination.more = that.pagination.more;
    }

    that.pagination = pagination || { total: 0, more: false };

    const total = that.pagination.total;
    const actionClass = total ? "addClass" : "removeClass";

    that.box.find(".siggma-notify-header > .siggma-notify-number")
      .html(total)[total ? "show" : "hide"]();
    that.boxInfo.find(".siggma-notify-info-number")
      .html(total > 9 ? "+9" : total)[total ? "show" : "hide"]();
    that.boxInfo.find(".siggma-notify-info-bell")[actionClass]("s-icon-aviso");
  }

  function create(that) {
    setPagination(that);
    that.boxContent = that.box.find(".siggma-notify");

    that.box.find(".siggma-notify-read-all").on("click", function (e) {
      Yanda.util.stopEvent(e);
      if (that.pagination.total) {
        loading(that, true);
        that.trigger("removeAll");
      }
    });

    that.box.find(".siggma-notify-refresh").on("click", function () {
      isClean(that, "Carregando...");
      loading(that, true);
      that.trigger("refresh");
    });

    that.boxContent.on("scroll", function () {
      if (
        !that.loading && that.pagination.more &&
        this.scrollTop + this.clientHeight >= this.scrollHeight
      ) {
        that.trigger("fetch", ++that.page);
        return;
      }
    });
  }

  function remove(that, id) {
    loading(that, true);
    that.results = that.results.filter((item) => (item.id !== id));
    that.boxContent.find(`.siggma-notify-item[data-id=${id}]`).remove();
    that.trigger("remove", { id, page: that.page });
  }

  function load(that, setScroll) {
    if (!that.pagination?.total) {
      isClean(that);
      return;
    }

    const report = [];
    const { empresa, filial } = globalThis.Siggma;
    const scrollTop = that.boxContent.scrollTop;

    that.boxContent.html("");
    that.boxContent.scrollTop = 0;

    that.results.forEach((row) => {
      row.data?.report && report.push(row);

      const icon = row.data?.sound
        ? "mdi-volume-high"
        : "mdi-information-variant-circle";

      const $elm = $(
        `<div data-id="${row.id}" class="siggma-notify-item">
          <i class="mdi mdi-clock-outline">&nbsp;${row.time}</i>
          <div style="display: flex; align-items: flex-start;">
              <i class="mdi ${icon} mdi-24px"></i>
              <div style="flex: 1;">${row.content}</div>
              <i class="mdi mdi-close mdi-18px" style="cursor: pointer" data-id="${row.id}"></i>
          </div>
        </div>`,
      );

      if (row.data?.tela) {
        (row.data.empresa == empresa && row.data.filial == filial) &&
          $elm.on("click", function (e) {
            Yanda.util.stopEvent(e);
            jQuery("#zt-notify .zt-preview").trigger("click");
            globalThis.Yanda.newApl(row.data.tela, row.data);
          });
      }

      $elm.appendTo(that.boxContent);
    });

    that.pagination.more && $(
      '<div class="siggma-notify-item">Carregar mais...</div>',
    ).appendTo(that.boxContent);

    setScroll && (that.boxContent.scrollTop = scrollTop);

    that.boxContent.find(".mdi-close").on("click", function (e) {
      Yanda.util.stopEvent(e);
      remove(that, +this.dataset.id);
    });

    const uniqid = globalThis.Yanda.ctr.janelaDes?.uniqid;
    report.forEach((r) => {
      if (uniqid === r.data.uniqid && r.data.notify) {
        globalThis.Yanda.newApl(104, { url: r.data.report });
        remove(that, r.id);
        return;
      }
      if (r.data.notify) {
        globalThis.Notify.info(
          `${r.data.title} gerado com sucesso.<br><br>
          <a style="color: #0161b7;"
            onclick="globalThis.Yanda.newApl(104, {url: '${r.data.report}'});">
            <i><u>Abra aqui</u></i>
          </a><br>ou<br>
          <a style="color: #0161b7;"
            onclick="globalThis.Siggma.showNotify('');">
            <i><u>Acesse as notificações do sistema</u></i>
          </a>`,
          20000,
        );
        globalThis.fetch(
          `${globalThis.Siggma.basePath}/app/report/atualizar-notify?id=${r.id}`,
        );
      }
    });
  }

  function Notify(options) {
    this.box = options.box;
    this.maxId = 0;
    this.boxInfo = options.boxInfo;
    this.results = [];
    this.page = 1;
    this.pagination = { total: 0, more: false };
    this.options = {
      columns: [],
      noButtons: false,
    };
    $.extend(this.options, options);
    create(this);

    this.setData = (data) => {
      loading(this, false);
      setPagination(this, this.page, data?.pagination);

      const results = data?.results || [];
      const maxId = results
        .filter((notify) => notify.id > this.maxId && !!notify.data?.sound)
        .reduce((maxId, notify) => Math.max(maxId, notify.id), 0);

      if (maxId > this.maxId) {
        this.maxId = maxId;
        (new Audio(`${globalThis.Siggma.basePath}/sounds/question.wav`)).play();
      }

      if (this.page > 1) {
        results.forEach((novo) => {
          let isResult = false;
          this.results.forEach((item, i) => {
            if (item.id === novo.id) {
              isResult = true;
              this.results[i] = novo;
            }
          });
          !isResult && this.results.push(novo);
        });
        load(this);
        return;
      }

      this.results = results;
      load(this);
    };

    this.trigger = function (type, data) {
      $(this).triggerHandler(type, data);
    };

    /* enter, dblclick, select, add, edit, delete, close, open */
    this.on = function (type, data) {
      $(this).on(type, data);
      return this;
    };
  }
  return new Notify(options);
}
